import React, { HTMLAttributes } from 'react';

const Button = (properties: HTMLAttributes<HTMLButtonElement>) => {
  const { children, className, ...remainingProperties } = properties;
  return (
    <button
      {...remainingProperties}
      className={`bg-theme-green text-theme-black font-bold tracking-wider uppercase py-3 px-6 rounded-full ${
        className ?? ''
      }`}
    >
      {children}
    </button>
  );
};

export default Button;
